import React from 'react';
import { Select } from 'antd';
import { NO_VALUE_OPERATORS } from './operators';

const NO_VALUE = new Set(NO_VALUE_OPERATORS);
const NUM_COMPARE = new Set(['GREATER_THAN', 'GREATER_THAN_OR_EQUAL', 'LESS_THAN', 'LESS_THAN_OR_EQUAL']);

// One condition's value control. What renders depends on the field type and the
// chosen operator (see the matrix in the plan). Attribute types emit {values};
// product emits {productIds}. Renders nothing until an operator that needs a value
// is chosen.
export default function ConditionValueInput({
  type, operator, values = [], productIds = [], productOptions = [], onChange, idLabel = 'condition',
}) {
  if (!operator || NO_VALUE.has(operator)) return null;

  if (type === 'product') {
    return (
      <Select
        mode="multiple" showSearch optionFilterProp="label" style={{ minWidth: 200 }}
        placeholder="products…" aria-label={`${idLabel} products`}
        value={productIds.map(String)} options={productOptions}
        onChange={(vals) => onChange({ productIds: vals.map((v) => parseInt(v, 10)) })}
      />
    );
  }

  if (type === 'BOOLEAN') {
    return (
      <select aria-label={`${idLabel} value`} value={values[0] || ''}
        onChange={(e) => onChange({ values: [e.target.value] })}>
        <option value="" disabled>choose…</option>
        <option value="Yes">Yes</option>
        <option value="No">No</option>
      </select>
    );
  }

  if (type === 'DATE_TIME') {
    return (
      <input type="date" aria-label={`${idLabel} value`} value={values[0] || ''}
        onChange={(e) => onChange({ values: e.target.value ? [e.target.value] : [] })} />
    );
  }

  if (type === 'NUMBER' && NUM_COMPARE.has(operator)) {
    return (
      <input type="number" aria-label={`${idLabel} value`} value={values[0] != null ? values[0] : ''}
        onChange={(e) => onChange({ values: e.target.value === '' ? [] : [e.target.value] })} />
    );
  }

  if (type === 'TEXT' && (operator === 'CONTAINS' || operator === 'DOES_NOT_CONTAIN')) {
    return (
      <input type="text" aria-label={`${idLabel} value`} value={values[0] || ''}
        onChange={(e) => onChange({ values: e.target.value === '' ? [] : [e.target.value] })} />
    );
  }

  // Default: multi-value tags — TEXT/NUMBER with INCLUSIVE/EXCLUSIVE ("is one of").
  return (
    <Select
      mode="tags" style={{ minWidth: 160 }} placeholder="value(s)…"
      aria-label={`${idLabel} values`} value={values}
      onChange={(vals) => onChange({ values: vals })}
    />
  );
}
